import { createIcon } from '@chakra-ui/react'

export const XIcon = createIcon({
  displayName: 'XIcon',
  viewBox: '0 0 20 20',
  path: [
    <path
      key="bg1"
      d="M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z"
      fill="currentColor"
    />,
    <path
      key="bg2"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
      fill="currentColor"
    />,
    <path
      key="x"
      d="M11.0465 9.36946L15.1415 4.5H14.1711L10.6154 8.72809L7.77551 4.5H4.5L8.79451 10.8936L4.5 16H5.47044L9.22533 11.535L12.2245 16H15.5L11.0465 9.36946ZM5.8201 5.24732H7.31064L14.1716 15.2867H12.681L5.8201 5.24732Z"
      fill="#fff"
    />,
  ],
})
